import { currentLocale } from "./i18nFormat";

export function getViewerTimeZone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
}

export function formatViewerDateTime(value, locale = currentLocale(), options = {}, timeZone = getViewerTimeZone()) {
  if (value == null || value === "") return "—";
  const date = value instanceof Date ? value : new Date(value);
  if (!Number.isFinite(date.getTime())) return "—";
  return new Intl.DateTimeFormat(locale, { ...options, timeZone }).format(date);
}
